import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
          light: {
            primary: '#2F2E3C',
            secondary: '#9bd3d8',
            accent: '#f77236',
            error: colors.red.accent3,
          },
          dark: {
            primary: '#2F2E3C',
            secondary: '#9bd3d8',
            accent: '#f77236',
            error: colors.red.accent3,
          },
        },
      },
});
